module.exports = __webpack_public_path__ + "img/app.efaa7c0b.svg";